import {dutchSidecodes, getDutchSideCode} from './dutch_side_codes.ts';
import {belgianSidecodes, getBelgianSideCode} from './belgian_side_codes.ts';
import {germanSidecodes, getGermanSideCode} from './german_side_codes.ts';

export function formatLicensePlate(license_plate: string) {
    const dutchSideCodeIndex = getDutchSideCode(license_plate);
    if (dutchSideCodeIndex !== null) {
        const matches = license_plate.match(dutchSidecodes[dutchSideCodeIndex]) ?? [];
        matches.shift();

        return matches.join('-');
    }
    const belgianSideCodeIndex = getBelgianSideCode(license_plate);
    if (belgianSideCodeIndex !== null) {
        const matches = license_plate.match(belgianSidecodes[belgianSideCodeIndex]) ?? [];
        matches.shift();

        return matches.join('-');
    }
    const germanSideCodeIndex = getGermanSideCode(license_plate);
    if (germanSideCodeIndex !== null) {
        const matches = license_plate.match(germanSidecodes[germanSideCodeIndex]) ?? [];
        matches.shift();

        return matches.join('-');
    }

    return license_plate;
}
